<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";

export default {
    components: {
        Layout,
        PageHeader
    },
    data() {
        return {
            data: {},
        };
    },
    mounted() {
        var vm = this;

        vm.load();
    },
    watch: {
        $route() {
            var vm = this;

            vm.load();
        }
    },
    methods: {
        load() {
            var vm = this;

            if (vm.$route.params.id) {
                vm.create();
            } else {
                vm.newData();
            }
        },
        newData() {
            var vm = this;

            var data = {
                id: null,
                shape_id: null,
                name: null,
                width: null,
                height: null,
                color: null,
                text_color: null,
                is_static: 0,
            };

            vm.data = Object.assign({}, data);
        },
        async create() {
            var vm = this;

            this.$loading.on('stuff_type_detail_create');
            try {
                vm.newData();

                var resp = await this.$api.StuffType.get(vm.$route.params.id);
                var data = resp.data.data;

                vm.data = data;

                this.$loading.off('stuff_type_detail_create');
            } catch (err) {
                this.$flash.error(err.response.data.message);
            }
        },
        async submit() {
            var vm = this;
            this.$loading.on('stuff_type_detail_submit');

            try {
                var postData = vm._createPostData(vm.data);
                var resp = await this.$api.StuffType.create(postData);

                var data = resp.data;

                if (vm.$route.params.id) {
                    vm.create();
                } else {
                    vm.$router.push({ name: 'stuff-type-detail', params: { id: data.data } });
                }

                this.$flash.success(data.message);
            } catch (err) {
                this.$flash.error(err.response.data.message);
            }
            this.$loading.off('stuff_type_detail_submit');
        },
        _createPostData: function (data) {

            return data;
        },

        //============
        fetchShape: async function (params) {
            var newParams = {
                ...params,
                group_by: 'shape',
            };

            const resp = await this.$api.Category.all(newParams)

            const data = resp.data.data

            const list = data.map(row => ({
                id: row.id,
                text: row.text,
                model: row,
            }))

            const meta = resp.data.meta

            return {
                options: list,
                more: meta.current_page < meta.last_page
            }
        },
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="$t('stuff_type.title.form')" :pageTitle="$t('menu.sub_header.dashboard')" />

        <BRow class="justify-content-center">
            <BCol lg="8">
                <b-form @submit="submit()">
                    <BCard no-body>
                        <BCardBody>
                            <loading :loading="$loading.get('stuff_type_detail_create')" variant="dark" type="block">
                                <BRow>
                                    <BCol class="mb-3" lg="12">
                                        <label for="choices-publish-status-input" class="form-label">{{
                                            $t('stuff_type.label.shape') }}</label>
                                        <dynamic-select v-model="data.shape_id"
                                            :loadOptions="fetchShape"
                                            :placeholder="$t('stuff_type.placeholder.shape')" />
                                    </BCol>
                                    <BCol class="mb-3" lg="12">
                                        <label class="form-label" for="product-title-input">{{
                                            $t('stuff_type.label.name')
                                        }}</label>
                                        <input type="text" class="form-control" v-model="data.name"
                                            id="product-title-input" :placeholder="$t('stuff_type.placeholder.name')" />
                                    </BCol>
                                    <BCol class="mb-3" lg="12">
                                        <label class="form-label" for="product-title-input">{{
                                            $t('stuff_type.label.width')
                                        }}</label>
                                        <input type="number" step="1" class="form-control" v-model="data.width"
                                            id="product-title-input"
                                            :placeholder="$t('stuff_type.placeholder.width')" />
                                    </BCol>
                                    <BCol class="mb-3" lg="12">
                                        <label class="form-label" for="product-title-input">{{
                                            $t('stuff_type.label.height')
                                        }}</label>
                                        <input type="number" step="1" class="form-control" v-model="data.height"
                                            id="product-title-input"
                                            :placeholder="$t('stuff_type.placeholder.height')" />
                                    </BCol>
                                    <BCol class="mb-3" lg="12">
                                        <label class="form-label" for="product-title-input">{{
                                            $t('stuff_type.label.color')
                                        }}</label>
                                        <input type="text" class="form-control" v-model="data.color"
                                            id="product-title-input"
                                            :placeholder="$t('stuff_type.placeholder.color')" />
                                    </BCol>
                                    <BCol class="mb-3" lg="12">
                                        <label class="form-label" for="product-title-input">{{
                                            $t('stuff_type.label.text_color')
                                        }}</label>
                                        <input type="text" class="form-control" v-model="data.text_color"
                                            id="product-title-input"
                                            :placeholder="$t('stuff_type.placeholder.text_color')" />
                                    </BCol>
                                    <BCol class="mb-3" lg="12">
                                        <BFormGroup class="mb-2">
                                            <BFormCheckbox v-model="data.is_static" id="formCheck1" :value="1"
                                                :unchecked-value="0">{{ $t('stuff_type.label.static') }}
                                            </BFormCheckbox>
                                        </BFormGroup>
                                    </BCol>

                                </BRow>
                            </loading>
                        </BCardBody>
                        <BCardFooter v-if="($ac.hasAccess('stuff_type_create'))">
                            <div class="hstack gap-2 justify-content-end">
                                <BButton type="submit" variant="success" class="w-sm"
                                    :disabled="$loading.get('stuff_type_detail_submit')"
                                    v-if="($ac.hasAccess('stuff_type_create'))">
                                    <loading :loading="$loading.get('stuff_type_detail_submit')">
                                        <i class="mdi mdi-floppy me-1"></i>
                                        {{ $t('basic.btn.save') }}
                                    </loading>
                                </BButton>
                            </div>
                        </BCardFooter>
                    </BCard>
                </b-form>
            </BCol>
        </BRow>
    </Layout>
</template>